var Spacings;
(function (Spacings) {
    Spacings["xxxxxxLarge"] = "8rem";
    Spacings["xxxxxLarge"] = "6rem";
    Spacings["xxxxLarge"] = "5rem";
    Spacings["xxxLarge"] = "4rem";
    Spacings["xxLarge"] = "3rem";
    Spacings["xLarge"] = "2rem";
    Spacings["large"] = "1.5rem";
    Spacings["medium"] = "1rem";
    Spacings["small"] = "0.75rem";
    Spacings["xSmall"] = "0.5rem";
    Spacings["xxSmall"] = "0.25rem";
    Spacings["none"] = "0rem";
})(Spacings || (Spacings = {}));
export default Spacings;
export const createCustomSpacing = (multiplier) => `${multiplier}rem`;
